export const cm2mm = (cm: number) => cm * 10;

